const NAVIGATION_PAGE_NAME = Object.freeze({
    BANK_TRANSACTION: "BANK_TRANSACTION",
    CASH_TRACKER: "CASH_TRACKER",
    WORK_LIST: "WORK_LIST",
});

export {
    NAVIGATION_PAGE_NAME,
};
